import 'babel-polyfill';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './views/App/App';
import { BrowserRouter, Route } from 'react-router-dom';
import { apiSelector } from './helpers/api/api';
import { registerLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
registerLocale('en-GB', enGB);

const myDomain = document.location.hostname;
const api = apiSelector(myDomain);

declare global {
  interface Window {
    apiBase: string;
    apiImg: string;
    apiFile: string;
    apiBaseFile: string;
    turnstileSiteKey: string;
  }
}

window.apiBase = api.main;
window.apiImg = api.img;
window.apiFile = api.file;
window.apiBaseFile = api.baseFile;
window.turnstileSiteKey = api.turnstileSiteKey;

const container = document.getElementById('app');
createRoot(container).render(
  <BrowserRouter>
    <Route component={App} />
  </BrowserRouter>
);
